import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Link from "next/link";

// ── FIXED & PREMIUM IMAGE MAP ──────────────────────────────────────────
const IMAGES = {
  // Popular
  "United States":   "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=600&q=80",
  "United Kingdom":  "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=600&q=80",
  "Canada":          "https://images.unsplash.com/photo-1517935706615-2717063c2225?q=80&w=465&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "Australia":       "https://images.unsplash.com/photo-1524562865630-b991c6c2f261?q=80&w=464&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "New Zealand":     "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?q=80&w=871&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "Ireland":         "https://images.unsplash.com/photo-1549877452-9c387954fbc2?auto=format&fit=crop&w=600&q=80", // Fixed
  "South Africa":    "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?auto=format&fit=crop&w=600&q=80",

  // High Demand
  "Schengen Area":   "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?auto=format&fit=crop&w=600&q=80",
  "Singapore":       "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?auto=format&fit=crop&w=600&q=80",
  "Malaysia":        "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?auto=format&fit=crop&w=600&q=80",
  "Thailand":        "https://images.unsplash.com/photo-1504214208698-ea1916a2195a?auto=format&fit=crop&w=600&q=80",
  "Japan":           "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=600&q=80",
  "South Korea":     "https://images.unsplash.com/photo-1506816561089-5cc37b3aa9b0?q=80&w=975&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "Turkey":          "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=600&q=80",
  "Georgia":         "https://images.unsplash.com/photo-1561731172-9d906d7b13bf?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Fixed
  "Azerbaijan":      "https://images.unsplash.com/photo-1563245372-f21724e3856d?auto=format&fit=crop&w=600&q=80",
  "Armenia":         "https://images.unsplash.com/photo-1563284223-333497472e88?q=80&w=876&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Fixed

  // Gulf
  "UAE":             "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=600&q=80",
  "Saudi Arabia":    "https://images.unsplash.com/photo-1586724237569-f3d0c1dee8c6?auto=format&fit=crop&w=600&q=80",
  "Qatar":           "https://images.unsplash.com/photo-1700901742651-6b353164caf3?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Fixed
  "Oman":            "https://images.unsplash.com/photo-1599743777555-e362a2feab39?q=80&w=388&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Fixed
  "Kuwait":          "https://images.unsplash.com/photo-1558634742-56096b49522b?q=80&w=966&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "Bahrain":         "https://images.unsplash.com/photo-1547548731-e95343697eb4?q=80&w=1032&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

  // Asia
  "Indonesia":       "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=600&q=80",
  "Maldives":        "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=600&q=80",
  "Sri Lanka":       "https://images.unsplash.com/photo-1571406761758-9a3eed5338ef?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "Vietnam":         "https://images.unsplash.com/photo-1528360983277-13d401cdc186?auto=format&fit=crop&w=600&q=80",
  "Cambodia":        "https://images.unsplash.com/photo-1508009603885-50cf7c579365?auto=format&fit=crop&w=600&q=80",
  "China":           "https://images.unsplash.com/photo-1547981609-4b6bfe67ca0b?auto=format&fit=crop&w=600&q=80",
  "India":           "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=600&q=80",

  // Europe
  "Germany":         "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=600&q=80",
  "France":          "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=600&q=80",
  "Italy":           "https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?auto=format&fit=crop&w=600&q=80",
  "Spain":           "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?auto=format&fit=crop&w=600&q=80",
  "Netherlands":     "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?auto=format&fit=crop&w=600&q=80",
  "Belgium":         "https://images.unsplash.com/photo-1491557345352-5929e343eb89?auto=format&fit=crop&w=600&q=80",
  "Austria":         "https://images.unsplash.com/photo-1516550893923-42d28e5677af?auto=format&fit=crop&w=600&q=80",
  "Sweden":          "https://images.unsplash.com/photo-1509356843151-3e7d96241e11?auto=format&fit=crop&w=600&q=80",
  "Poland":          "https://images.unsplash.com/photo-1519197924294-4ba991a11128?auto=format&fit=crop&w=600&q=80",
  "Portugal":        "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?auto=format&fit=crop&w=600&q=80",
  "Switzerland":     "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=600&q=80",
  "Serbia":          "https://images.unsplash.com/photo-1613601740367-410ae03b2ec7?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
};

const SECTIONS = [
  {
    title: "Popular Destinations",
    data: ["United States","United Kingdom","Canada","Australia","New Zealand","Ireland","South Africa"],
  },
  {
    title: "High-Demand Destinations",
    data: ["Schengen Area","Singapore","Malaysia","Thailand","Japan","South Korea","Turkey","Georgia","Azerbaijan","Armenia"],
  },
  {
    title: "Gulf Countries",
    data: ["UAE","Saudi Arabia","Qatar","Oman","Kuwait","Bahrain"],
  },
  {
    title: "Asia",
    data: ["Thailand","Malaysia","Singapore","Indonesia","Maldives","Sri Lanka","Vietnam","Cambodia","China","India"],
  },
  {
    title: "Europe",
    data: ["Germany","France","Italy","Spain","Netherlands","Belgium","Austria","Sweden","Poland","Portugal","Serbia"],
  },
  {
    title: "Schengen Visa",
    data: ["Austria","Belgium","France","Germany","Italy","Netherlands","Spain","Sweden","Switzerland"],
  },
];

const SECTION_ANCHORS = {
  "Gulf Countries": "gulf",
  Asia: "asia",
  Europe: "europe",
};

function VisaCard({ title }) {
  const img = IMAGES[title] || "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600&q=80";
  
  return (
    <div className="group bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-[0_15px_30px_rgba(184,137,58,0.08)] border border-gray-100 flex flex-col justify-between w-full">
      <div>
        {/* Aspect Ratio container with overlay gradient */}
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-gray-100">
          <img
            src={img}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
        
        {/* Card Body */}
        <div className="p-5">
          <p className="text-[10px] font-bold text-[#B8893A] tracking-widest uppercase mb-1">Explore</p>
          <h3 className="text-lg font-bold text-[#111111] tracking-tight group-hover:text-[#B8893A] transition-colors duration-300">{title}</h3>
        </div>
      </div>

      <div className="px-5 pb-5 pt-0">
        <a
          href="https://wa.me/971507987470"
          target="_blank"
          rel="noopener noreferrer"
          className="block text-center w-full py-3 rounded-xl text-white font-bold text-xs tracking-wider uppercase transition-all duration-300 hover:bg-[#a3762f] shadow-sm shadow-amber-900/10 active:scale-[0.98]"
          style={{ background: "#B8893A" }}
        >
          APPLY NOW
        </a>
      </div>
    </div>
  );
}

export default function VisaServices() {
  return (
    <main className="bg-[#FCFCFC] min-h-screen w-full overflow-x-hidden selection:bg-amber-50">
      <Navbar />

      {/* HERO SECTION - Premium Minimalist Center */}
      <section className="w-full px-4 sm:px-8 lg:px-16 pt-32 pb-16 relative">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#B8893A]/5 rounded-full blur-[120px] pointer-events-none" />
        
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <span className="inline-block px-3 py-1 rounded-full border border-[#B8893A]/30 bg-[#B8893A]/5 text-[10px] sm:text-xs font-bold text-[#B8893A] uppercase tracking-[0.2em] mb-4">
            Seamless Immigration Assistance
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-black tracking-tight leading-[1.15] mb-6">
            Global Visa Services
          </h1>
          <p className="text-gray-500 text-base sm:text-lg max-w-2xl mx-auto font-light leading-relaxed mb-8">
            Fast, reliable visa assistance for top travel destinations worldwide. 
            Simple process, structured guidance, and higher approval-focused strategy.
          </p>
          <a
            href="https://wa.me/971507987470"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-10 py-4 text-white rounded-xl font-bold text-sm tracking-wide shadow-lg shadow-amber-950/10 transition-all duration-300 hover:bg-[#a3762f] hover:scale-[1.02] active:scale-[0.98]"
            style={{ background: "#B8893A" }}
          >
            Get Started
          </a>
        </div>
      </section>

      {/* SECTIONS GRIDS */}
      {SECTIONS.map((section) => (
        <section key={section.title} id={SECTION_ANCHORS[section.title]} className="px-4 sm:px-8 lg:px-16 py-12 border-t border-gray-100/60 first:border-t-0 ">
          <div className="max-w-[1600px] mx-autoWide">
            <div className="flex flex-col mb-8">
              <h2 className="text-2xl sm:text-3xl font-black text-[#111111] tracking-tight">
                {section.title}
              </h2>
              <div className="w-12 h-[3px] bg-[#B8893A] mt-2 rounded-full" />
            </div>

            {/* Grid Layout perfectly balanced for massive 2K/4K and smaller phone screens */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6 ">
              {section.data.map((item) => (
                <VisaCard key={item} title={item} />
              ))}
            </div>
          </div>
        </section>
      ))}

    </main>
  );
}